module.exports = require("@swa-ui/itinerary/src/FlightConfirmationCard/FlightConfirmationCard.module.scss");